/** Whether Insights should run a second Bedrock pass to cluster aggregate rows into themes. */
export function shouldSummarizeInsights(question: string): boolean {
  const q = question.toLowerCase();
  const wantsThemes =
    /\b(primary|main|top|leading|key|common|frequent|typical|popular|most)\b/.test(
      q,
    ) && /\b(reason|cause|why|driver|pattern)\b/.test(q);
  const explicitSummarize =
    /\b(summarize|summary|themes?|category|categories|categorize|categorization|cluster|group.*reason)\b/.test(
      q,
    ) ||
    (/\bwhat are the (primary|main|top)\b/.test(q) &&
      /\b(themes?|reasons?|causes?|categor(?:y|ies)|topics?)\b/.test(q));
  return wantsThemes || explicitSummarize;
}
